var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"semibold",style:("color:" + _vm.infrastructureText.color)},[_vm._v(_vm._s(_vm.infrastructureText.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }